

let collection = [];
let active = null;
let els = {};
const bodyClassname = 'moka-has-windows';
const windowOuterClassname = 'moka-window';
const activeClassname = 'active';


export default class Windows {
	

	
	constructor() {
		const _this = this;
		
		els.wrapper = document.getElementById('mwin-c');
		els.container = document.getElementById('mwin-h');
		
		els.container.addEventListener('click', event => {
			if( event.target.matches('.mwin--close-btn') ) {
				_this.close(active);
			}
		});
		
		document.addEventListener('keyup', event => {
			if(event.code === 'Escape' && active) {
				_this.close(active);
				event.stopPropagation();
			}
		});
	}
	
	
	open(windowHtml) {
		if( collection.length === 0 ) {
			this.#prepare();
		}
		
		const identifier = 'mwin-'+ Date.now();
		const win = document.createElement('div');
		win.classList.add(windowOuterClassname);
		win.dataset.identifier = identifier;
		win.id = identifier;
		win.innerHTML = windowHtml;
		
		const scripts = Array.from(win.querySelectorAll('script'));
		scripts.forEach(s => {
			const g = document.createElement('script');
			if(! s.text && ! s.src ) {
				return;
			}
			
			if( s.text ) {
				g.text = s.text;
			}
			
			if( s.src ) {
				g.src = s.src;
			}
			
			s.parentNode.insertBefore(g, s);
			s.parentNode.removeChild(s);
			
			//win.appendChild(g);
		});
		
		const draggableWindow = win.querySelector('.mwin[draggable]');
		if(draggableWindow) {
			draggableWindow.addEventListener('dragend', event => {
				console.log('dragend');
				event.stopPropagation(); 
				return false;
			});
			draggableWindow.addEventListener('drop', event => {
				console.log(draggableWindow, 'end');
				event.stopPropagation(); 
				return false;
			});
		}

		els.container.appendChild(win);
		
		// Ads to collection
		collection.push(identifier);
		
		// Make it active
		this.setActive(identifier);
		
		const event = new CustomEvent('mokaWindowOpen', { detail: { identifier: identifier }});
		document.dispatchEvent(event);
	}
	
	
	close(win = null) {
		// select dom element and remove it 
		const _win = win === null ? active : win;
		
		// remove from array 
		collection = collection.filter(c => _win !== c);
		
		const w = this.#getWindow(_win);
		if( w ) {
			els.container.removeChild(w);
		}
		
		const event = new CustomEvent('mokaWindowClose', { detail: { identifier: _win }});
		document.dispatchEvent(event);
		
		if( collection.length === 0 ) {
			this.#removeAll();
			active = null;
			return;
		}
		
		// maybe change active 
		if( active === _win ) {
			this.setActive(collection[0]);
		}
	}
	
	
	getActive() {
		return active;
	}
	
	
	setActive(win) {
		const el = this.#getWindow(win);
		if( el && active !== win ) {
			const _actives = Array.from(els.container.querySelectorAll('.'+ windowOuterClassname +'.'+ activeClassname));
			_actives.forEach(_a => {
				_a.classList.remove(activeClassname);
			});
			active = win;
			el.classList.add(activeClassname);
			
			const event = new CustomEvent('mokaWindowSwitch', { detail: { windowElement: el }});
			document.dispatchEvent(event);
		}
	}
	
	
	#prepare() {
		els.wrapper.style.display = 'block';
		document.body.classList.add( bodyClassname );
	}
	
	
	#removeAll() {
		els.wrapper.style.display = 'none';
		document.body.classList.remove( bodyClassname );
	}
	
	#getWindow(w) {
		return document.getElementById(w);
	}
	
}